import React, {Component} from 'react';
import {FormControl} from "react-bootstrap";
import {TopButtonPointAction} from "../../../../componentsTopsa/buttons/TopButtons";
import moment from 'moment'
import Validator from "../../../../utilities/Validator";
import DateAndTimeFormat from "../../../../utilities/DateAndTimeFormat";
import {TopInputDate} from "../../../../componentsTopsa/inputs/TopInputs";

export default class KonfiguracjaWartoscKomorka extends Component {

    constructor(props) {
        super(props);
        this.state = {
            obiekt: {},
            wartosc: null,
            data: moment()
        };
        this.onChangeData = this.onChangeData.bind(this)
        this.onChangeNumer = this.onChangeNumer.bind(this)
        this.onChangeText = this.onChangeText.bind(this)
        this.onChangeColor = this.onChangeColor.bind(this)
        this.onClickZapisz = this.onClickZapisz.bind(this)
    }

    componentDidMount() {
        this.ustawWartosc(this.props)
    }

    componentWillReceiveProps(nextprops) {
        this.ustawWartosc(nextprops)
    }

    ustawWartosc(props) {
        this.setState({wartosc: props.wartosc, obiekt: props.obiekt})

    }

    onChangeData(e) {
        this.setState({data: e})
    }

    onChangeNumer(e) {
        this.setState({wartosc: e.target.value})
    }

    onChangeText(e) {
        this.setState({wartosc: e.target.value})
    }

    onClickZapisz() {
        let obj = this.state.obiekt

        obj.wartosc = this.state.wartosc

        if (this.state.obiekt.sekcja === 'Bilety') {
            if (!Validator.validateInt(this.state.wartosc, false)) {
                alert('Niepoprawna wartość! Wymagana liczba całkowita dodatnia')
            } else {

                this.props.handleClickZapisz(obj)
            }
        }
        else if (this.state.obiekt.pozycja === "Data od" || this.state.obiekt.pozycja === "Data do") {
            if (/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/.test(this.state.wartosc)) {

                this.props.handleClickZapisz(obj)
            } else alert("Niepoprawny format daty! Powinien być YYYY-MM-DD")
        }
        else {
            this.props.handleClickZapisz(obj)
        }
    }

    onChangeColor(e) {
        this.setState({wartosc: e.color})
    }

    render() {

        return (
            <div>
                <div style={{display: 'inline-block', width: '250px'}}>
                    <FormControl onChange={this.onChangeText} defaultValue={this.state.wartosc}/>
                </div>
                <TopButtonPointAction onClick={() => {
                    this.onClickZapisz()
                }} buttonColor={'primary'} buttonIcon={'fa fa-check'}/>
                <TopButtonPointAction onClick={() => {
                    this.props.handleClickAnuluj()
                }} buttonColor={'default'} buttonIcon={'fa fa-times'}/>

            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/administracja/konfiguracja/components/KonfiguracjaWartoscKomorka.js